import React from "react";

import AntdDivider from "antd/es/divider";

import styles from "./Divider.module.scss";

interface Props {}

const Divider: React.FC<Props> = () => <AntdDivider className={styles.container} />;

export default Divider;
